var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8086 23.8686H8.17679C5.87076 23.8686 4 21.9978 4 19.6918V13.459C4 11.153 5.87076 9.28223 8.17679 9.28223H18.8086C21.1146 9.28223 22.9854 11.153 22.9854 13.459V14.7926C22.9854 15.1723 22.6705 15.4872 22.2908 15.4872H20.42C20.0959 15.4872 19.7995 15.6076 19.5865 15.8299L19.5773 15.8391C19.318 16.0892 19.1976 16.4318 19.2254 16.7838C19.2809 17.395 19.8644 17.8858 20.5312 17.8858H22.2908C22.6705 17.8858 22.9854 18.2007 22.9854 18.5804V19.6825C22.9854 21.9978 21.1146 23.8686 18.8086 23.8686ZM8.17679 10.6714C6.63943 10.6714 5.38917 11.9217 5.38917 13.459V19.6918C5.38917 21.2291 6.63943 22.4794 8.17679 22.4794H18.8086C20.346 22.4794 21.5962 21.2291 21.5962 19.6918V19.2843H20.5312C19.1327 19.2843 17.9473 18.247 17.8362 16.9134C17.7621 16.154 18.0399 15.4039 18.5956 14.8574C19.0772 14.3666 19.7255 14.098 20.42 14.098H21.5962V13.459C21.5962 11.9217 20.346 10.6714 18.8086 10.6714H8.17679Z",
    fill: "url(#paint0_linear_2256_121373)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69459 14.9866C4.31488 14.9866 4 14.6718 4 14.292V10.0598C4 8.67984 4.87055 7.42953 6.15785 6.93869L13.5112 4.16034C14.2706 3.87325 15.1134 3.97516 15.7709 4.43821C16.4377 4.90127 16.8267 5.65143 16.8267 6.45715V9.97637C16.8267 10.3561 16.5118 10.671 16.1321 10.671C15.7524 10.671 15.4375 10.3561 15.4375 9.97637V6.45715C15.4375 6.10522 15.2708 5.78106 14.9745 5.57732C14.6781 5.37357 14.3262 5.32727 13.9928 5.45692L6.63943 8.23527C5.88928 8.52237 5.37991 9.25403 5.37991 10.0598V14.292C5.38917 14.681 5.0743 14.9866 4.69459 14.9866Z",
    fill: "url(#paint1_linear_2256_121373)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.532 19.2839C19.1335 19.2839 17.9481 18.2467 17.837 16.9131C17.7629 16.1444 18.0407 15.3942 18.5964 14.8478C19.0687 14.3662 19.717 14.0977 20.4116 14.0977H22.3379C23.2548 14.1254 23.9586 14.8478 23.9586 15.7369V17.6447C23.9586 18.5338 23.2548 19.2561 22.3657 19.2839H20.532ZM22.3194 15.4868H20.4208C20.0967 15.4868 19.8003 15.6072 19.5873 15.8295C19.3188 16.0888 19.1891 16.4407 19.2262 16.7927C19.2817 17.4039 19.8652 17.8947 20.532 17.8947H22.3472C22.4676 17.8947 22.5787 17.7836 22.5787 17.6447V15.7369C22.5787 15.598 22.4676 15.4961 22.3194 15.4868Z",
    fill: "url(#paint2_linear_2256_121373)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3449 14.6069H8.86207C8.48236 14.6069 8.16748 14.2921 8.16748 13.9124C8.16748 13.5327 8.48236 13.2178 8.86207 13.2178H15.3449C15.7246 13.2178 16.0395 13.5327 16.0395 13.9124C16.0395 14.2921 15.7246 14.6069 15.3449 14.6069Z",
    fill: "url(#paint3_linear_2256_121373)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2256_121373",
    x1: 19.6955,
    y1: 4.51032,
    x2: 8.54908,
    y2: 52.0193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2256_121373",
    x1: 14.604,
    y1: 0.405731,
    x2: 5.36116,
    y2: 35.7423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2256_121373",
    x1: 22.8958,
    y1: 12.401,
    x2: 18.5815,
    y2: 29.1089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2256_121373",
    x1: 14.6754,
    y1: 12.7633,
    x2: 14.4189,
    y2: 17.5232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.26
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.070dd0dd931ebf0df8628136599871bf.svg";
export { ForwardRef as ReactComponent };